var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Headings";
import Button from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import Validation from "@irati/utils/validation";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { hangPromise } from "@irati/utils/promise";
import Flex from "@irati/ui/src/Flex";
import IconPicker from "./IconPicker";
import { FlexRowSpaceBetween50Buttons, Input, H4 } from "./styled";
var EditForm = /** @class */ (function (_super) {
    __extends(EditForm, _super);
    function EditForm(props) {
        var _this = _super.call(this, props) || this;
        _this.selectIcon = function (icon) {
            _this.setState({ icon: icon });
        };
        _this.handleSubmit = function () {
            var _a = _this.state, name = _a.name, tag = _a.tag, icon = _a.icon;
            var _b = _this.props, occasion = _b.occasion, upsertOccasion = _b.upsertOccasion;
            var upserting = hangPromise();
            if (occasion) {
                upserting = upsertOccasion(name, tag, icon, occasion.uuid);
            }
            else {
                upserting = upsertOccasion(name, tag, icon);
            }
            _this.setState({ upserting: upserting });
        };
        _this.state = {
            name: "",
            tag: "",
            icon: ""
        };
        // Defaulting state to props values (edit)
        var occasion = _this.props.occasion;
        if (occasion) {
            var name = occasion.name, tag = occasion.tag, icon = occasion.icon;
            _this.state = { name: name, tag: tag, icon: icon.href };
        }
        return _this;
    }
    EditForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, name = _a.name, tag = _a.tag, icon = _a.icon, upserting = _a.upserting;
        var _b = this.props, formatMessage = _b.formatMessage, occasion = _b.occasion;
        var closeModal = this.props.closeModal;
        var editOrCreateLabel = occasion ? "admin.occasions.create.buttons.saveEdit.label" : "admin.occasions.create.buttons.create.label";
        return (React.createElement(Row, null,
            React.createElement(Col, { md: 6, mdOffset: 3 },
                React.createElement(Flex, { justifyContent: "space-around", margin: "15px 0" },
                    React.createElement(H2, null,
                        React.createElement(FormattedMessage, { id: "admin.occasions.create.title" }))),
                React.createElement(Flex, { justifyContent: "space-around" },
                    React.createElement(H4, null,
                        React.createElement(FormattedMessage, { id: "admin.occasions.create.description" })))),
            React.createElement(Row, null,
                React.createElement(Row, null,
                    React.createElement(Col, { md: 6, mdOffset: 3 },
                        React.createElement(Input, { label: formatMessage({ id: "admin.occasions.create.fields.name.label" }), placeholder: formatMessage({ id: "admin.occasions.create.fields.name.placeholder" }), name: "name", value: name, onChange: function (newName) { return _this.setState({ name: newName }); }, validation: Validation.string("admin.helpers.codeSchema.validation.string") }))),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 6, mdOffset: 3 },
                        React.createElement(Input, { label: formatMessage({ id: "admin.occasions.create.fields.tag.label" }), placeholder: formatMessage({ id: "admin.occasions.create.fields.tag.placeholder" }), hint: formatMessage({ id: "admin.occasions.create.fields.tag.hint" }), name: "tag", value: tag, margin: "15px 0", onChange: function (newTag) { return _this.setState({ tag: newTag }); }, validation: Validation.string("admin.helpers.codeSchema.validation.string") })))),
            React.createElement(Col, { md: 6, mdOffset: 3 },
                React.createElement(IconPicker, { selectIcon: function (newIcon) { return _this.setState({ icon: newIcon }); }, selectedIcon: icon }),
                React.createElement(Loading, { load: upserting },
                    React.createElement(FlexRowSpaceBetween50Buttons, null,
                        React.createElement(Button, { onClick: closeModal },
                            React.createElement(FormattedMessage, { id: "admin.occasions.create.buttons.cancel.label" })),
                        React.createElement(ValidationButton, { primary: true, onClick: this.handleSubmit },
                            React.createElement(FormattedMessage, { id: editOrCreateLabel })))))));
    };
    return EditForm;
}(Component));
export default injectIntl(EditForm);
